import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { computed, withDefaults } from 'vue'
import BaseChart from '@/base-ui/chart'

import { convertData } from '../utils/convert-data'
import { IDataType } from '../types/type'


export default _defineComponent({
  props: {
    title: { type: String, required: false, default: '' },
    mapData: { type: Array, required: true }
  } as unknown as undefined,
  setup(__props: {
    title?: string
    mapData: IDataType[]
  }) {

const props = __props


const options = computed(() => {
  return {
    backgroundColor: '#fff',
    title: {
      text: '銷量統計',
      left: 'center',
      textStyle: {
        color: '#000'
      }
    },
    tooltip: {
      trigger: 'item',
      formatter: function (params: any) {
        return params.name + ' : ' + params.value[2]
      }
    },
    visualMap: {
      min: 0,
      max: 60000,
      left: 20,
      bottom: 20,
      calculable: true,
      text: ['高', '低'],
      inRange: {
        color: ['rgb(70, 240, 252)', 'rgb(250, 220, 46)', 'rgb(245, 38, 186)']
      },
      textStyle: {
        color: '#000'
      }
    },
    // 地理編碼
    geo: {
      // map: 'china',
      map: 'taiwan',
      roam: true,
      zoom: 1.2,
      center: [120.5151, 23.69295],
      emphasis: {
        areaColor: '#f4cccc',
        borderColor: 'rgb(9, 54, 95)',
        itemStyle: {
          areaColor: '#f4cccc'
        }
      }
    },
    series: [
      {
        name: '銷量',
        type: 'scatter',
        coordinateSystem: 'geo',
        data: convertData(props.mapData),
        // symbolSize: 15,
        zoom: 2,
        emphasis: {
          itemStyle: {
            borderColor: '#fff',
            borderWidth: 1
          }
        }
      },
      {
        type: 'map',
        map: 'taiwan',
        geoIndex: 0,
        aspectScale: 0.75,
        tooltip: {
          show: false
        }
      }
    ]
  }
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_unref(BaseChart), { options: _unref(options) }, null, 8, ["options"])
  ]))
}
}

})